<template>
    <div class="txt-white feedback bg-green">
        <div class="icon">V</div>
        <h3>Basilicum is erg vatbaar voor koude en wordt snel bruin</h3>
        <div class="next bg-lightGrey txt-mediumGrey"><h3>Volgende vraag</h3></div>        
        
        
    </div>
</template>

<script>
export default {
    name: "Feedback"
};
</script>

<style scoped>
.feedback {
    width:100%;
    position:absolute;
    bottom:0;
}
.next {
    display:inline-block;
    width:50%;
    height:5vh;
    border-radius: 25px 25px 0 0;
}
.next:hover {
    cursor:pointer;
}
</style>
